import React from 'react';

const Loading: React.FC = () => {
  return (
    <div className="spinner-wrapper">
      <div className="spinner-custom"></div>
    </div>
  );
};

export default Loading;
